var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrx = function SvgTrx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trx_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EF0027",
    d: "M22 44c12.15 0 22-9.85 22-22S34.15 0 22 0 0 9.85 0 22s9.85 22 22 22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.157 13.629 10.312 9.977l10.444 26.279 14.551-17.73zm-.32 1.608 3.037 2.886-8.303 1.503zm-7.07 4.088-8.75-7.257L28.32 14.7zm-.623 1.284-1.427 11.798-7.693-19.364zm1.32.626 9.195-1.664-10.546 12.847z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "trx_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
};
export default SvgTrx;